/**
 * Build a 1-2 character initials string for an avatar fallback.
 *
 * - Splits the name on whitespace and takes the first letter of each word.
 * - Returns the result uppercased and clamped to 2 characters.
 * - Returns "?" if the input has no usable letters (empty/whitespace only).
 */
export function initials(name: string): string {
  if (!name) return "?";
  const result = name
    .split(/\s+/)
    .filter(Boolean)
    .map((w) => w[0])
    .join("")
    .toUpperCase()
    .slice(0, 2);
  return result || "?";
}
